import * as React from 'react';
import { StackedDiagram } from '../../datenauswertung/helper/stackedBarChart';

export interface EnergiekostenKostenentwicklungProps {
    data: any;
    values: any;
}

export class EnergiekostenKostenentwicklung extends React.Component<EnergiekostenKostenentwicklungProps, {}> {

    private chartColors = [
        '#bccae3', '#6f91be', '#686868', '#728a49', '#ea9956', '#eee',
        '#4ea72e', '#a02b93', '#0f9ed5', '#156082', '#e97132', '#196b24',
        '#4f81bd', '#f79646', '#87bd51', '#5163bd', '#9951bd', '#bd5175'
    ];

    getChartData(): any {
        const { values } = this.props;
        const dataMap: any = {};
        const bars: any[] = [];
        Object.keys(values || {}).forEach((key: string, idx: number) => {
            Object.keys(values[key].jahre || {}).forEach((jahr: string) => {
                if (!dataMap[jahr]) {
                    dataMap[jahr] = [];
                }
                dataMap[jahr].push(values[key].jahre[jahr].kosten);
            });
            bars.push({ name: values[key].name2 || values[key].name, color: this.chartColors[idx % this.chartColors.length] });
        });
        const dataRows = Object.keys(dataMap).map((jahr: string) => {
            return {
                name: jahr,
                values: dataMap[jahr]
            }
        });
        return { dataRows, bars };
    }

    render(): JSX.Element {
        const { dataRows, bars } = this.getChartData();
        return <>
            <div style={{ fontSize: 12, fontWeight: 600, textAlign: 'center', padding: '15px 0', backgroundColor: '#efefef' }}>
                Prognostizierte Kostenentwicklung
            </div>
            <div style={{ fontSize: 12, padding: 10, marginLeft: -10 }}>
                {bars.length > 0 ?
                    <StackedDiagram
                        id='Chart_EnergiekostenKostenentwicklung'
                        key={`Chart_EnergiekostenPreisentwicklung_${bars.length}`}
                        fontSize={'12px'}
                        containerSize={{ width: '100%', height: 230 }}
                        data={dataRows}
                        bars={bars}
                        barProps={{ barSize: 35 }}
                        // xAxisProps={{ style: { fontSize: 11 }, /* height: 40, angle: -45 */ }}
                        yAxisProps={{ axisLine: false, tickLine: false, angle: 0, unit: ' €' }}
                    />
                    :
                    <p>Bitte wählen Sie mindestens einen Energieträger aus!</p>
                }
            </div>
        </>;
    }
}
